import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons';


function StudentVisa() {
  return (
    
    <main>
         <style>
        {`
          .visa-info {
            font-family: Arial, sans-serif;
            padding: 20px;
            color: #333;
          }

          .tr-visa-details-title {
            font-size: 1.5rem;
            margin-bottom: 16px;
            color: #222;
          }

          .visa-benefits,
          .country-list {
            list-style-type: none;
            padding-left: 0;
            margin: 0;
          }

          .visa-benefits li,
          .country-list li {
            margin-bottom: 16px;
            line-height: 1.6;
          }

          section {
            margin-bottom: 40px;
          }

          strong {
            display: inline-block;
            margin-bottom: 4px;
          }
        `}
      </style>
        
        <div class="tr-breadcurmb-area p-relative tr-breadcurmb-bg" style={{ backgroundImage: 'url(assets/img/breadcurmb/breadcurmb.jpg)' }}>
            <div class="tr-breadcurmb-shape-1">
                <img src="assets/img/breadcurmb/shape-1.png" alt=""/>
            </div>
            <div class="container" >
                <div class="row justify-content-center">
                    <div class="col-xl-8">
                        <div class="tr-breadcurmb-content text-center z-index-2" >
                            <div class="tr-breadcurmb-title-box">
                                <h3 class="tr-breadcurmb-title">Student Visa</h3>
                            </div>
                            <div class="tr-breadcurmb-list-wrap">
                                <div class="tr-breadcurmb-list">
                                    <span><a href="/">Home</a></span>
                                    <span class="dvdr"><i class="fa-regular fa-angles-right"></i></span>
                                    <i>Visa Details</i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

        
        <div class="tr-visa-details-area pt-120 pb-90" style={{textAlign: "left"}}>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="tr-visa-details-wrap">
                            <div class="tr-visa-details-thumb mb-35 wow img-custom-anim-top" data-wow-duration="1.5s" data-wow-delay=".3s">
                                <img class="w-100" src="assets/img/inner/visa/details.jpg" alt=""/>
                            </div>
                            <h4 class="tr-visa-details-title">Why Study Abroad?</h4>
                            <p class="mb-20">Studying abroad opens doors to top-tier education, diverse cultural experiences, and global career opportunities. However, the student visa process can often feel daunting. At Apex Advisors, we make it easy. With our expert guidance, you can focus on your academic aspirations while we handle the paperwork.</p>
                            <p class="mb-30">Our Comprehensive Student Visa Services Include:</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xl-8 col-lg-8">
                        <div class="tr-visa-details-wrap">
                            <h4 class="tr-visa-details-title">Why Study Abroad?</h4>
                            <p>Studying abroad opens doors to top-tier education, diverse cultural experiences, and global career opportunities. However, the student visa process can often feel daunting. At Apex Advisors, we make it easy. With our expert guidance, you can focus on your academic aspirations while we handle the paperwork.</p>
                            <h4 class="tr-visa-details-title">Step-by-Step Guidance</h4>
                            <p>We guide you through the entire student visa process, from start to finish. Our team provides detailed instructions on completing visa applications, scheduling visa appointments, and preparing for interviews.</p>
                            <h4 class="tr-visa-details-title">Document Preparation & Review:</h4>
                            <p>We assist you with gathering and preparing all the required documents, including financial proof, university acceptance letters, and personal statements. Our team ensures everything is in perfect order to avoid any last-minute issues.</p>
                            <h4 class="tr-visa-details-title">Visa Interview Preparation</h4>
                            <p>Nervous about the visa interview? We offer mock interviews and expert coaching to help you confidently answer visa officer questions. This preparation significantly increases your chances of a successful outcome.</p>
                            <h4 class="tr-visa-details-title">Country-Specific Expertise</h4>
                            <p>Our visa experts are knowledgeable about the requirements for different countries, including the USA, UK, Canada, Australia, and Europe. We tailor our services to meet the specific guidelines of your destination country.</p>
                            <h4 class="tr-visa-details-title">Fast-Track Processing</h4>
                            <p>We prioritize quick, accurate, and streamlined processing, ensuring that your visa application is submitted on time and with minimal delays.</p>
                            <h4 class="tr-visa-details-title">Post-Visa Support</h4>
                            <p>After your visa approval, we continue to assist you with pre-departure services, helping you understand travel requirements, health insurance, and more.</p>
           <div className="visa-info">
        <section className="visa-details">
          <h4 className="tr-visa-details-title">Why Choose Apex Advisors?</h4>
          <ul className="visa-benefits">
            <li>
              <strong style={{ color: 'black' }}>✅ Trusted Expertise:</strong><br />
              With years of experience, we specialize in securing student visas for top international universities.
            </li>
            <li>
              <strong style={{ color: 'black' }}>✅ Personalized Service:</strong><br />
              Every student is unique, and so is our approach. We provide customized guidance tailored to your course, destination country, and personal goals.
            </li>
            <li>
              <strong style={{ color: 'black' }}>✅ Transparent Process:</strong><br />
              No hidden fees, no surprises. Our clear and transparent process keeps you informed at every stage.
            </li>
            <li>
              <strong style={{ color: 'black' }}>✅ Proven Success Rate:</strong><br />
              Our high success rate in student visa approvals shows you're in expert hands.
            </li>
          </ul>
        </section>

        <section className="visa-countries">
          <h4 className="tr-visa-details-title">Countries We Serve</h4>
          <ul className="country-list">
            <li>
              <strong style={{ color: 'black' }}>USA:</strong><br />
              Apply to world-leading universities and benefit from Optional Practical Training (OPT) after graduation.
            </li>
            <li>
              <strong style={{ color: 'black' }}>UK:</strong><br />
              Study at prestigious institutions and gain access to up to two years of post-study work opportunities.
            </li>
            <li>
              <strong style={{ color: 'black' }}>Canada:</strong><br />
              Experience a vibrant academic life and access the Post-Graduation Work Permit (PGWP) program.
            </li>
            <li>
              <strong style={{ color: 'black' }}>Australia:</strong><br />
              Pursue education at top universities and explore work options via the Temporary Graduate Visa.
            </li>
            <li>
              <strong style={{ color: 'black' }}>Europe:</strong><br />
              Choose from countries like Germany, France, or the Netherlands—offering scholarships and part-time work opportunities.
            </li>
          </ul>
        </section>
      </div>

<h4 class="tr-visa-details-title">Let’s Make Your Study Abroad Dream a Reality!</h4>
<p>Apex Advisors is here to turn your aspirations into achievements. Contact us today to begin your hassle-free student visa application process.</p>

                            {/* <p class="mb-30"> A comprehensive evaluation of the client’s immigration needs and eligibility for various visa option Personalized consultation, initial assessment report, eligibility check, and tailored advice Document preparation, form filling,
                                application submission, and follow-up with immigration authorities</p> */}
                            <div class="tr-visa-details-list-box d-flex align-content-center flex-wrap mb-45">
                                <div class="tr-visa-details-list">
                                    <h4 class="tr-visa-details-title">Why Choose Us?</h4>
                                    <ul>
                                        <li><i class="fa-solid fa-circle-check"></i>Full Guidance</li>
                                        <li><i class="fa-solid fa-circle-check"></i>Tailored Solutions</li>
                                    </ul>
                                </div>
                                <div class="tr-visa-details-list style-2"><br></br><br></br>
                                    <ul>
                                        <li><i class="fa-solid fa-circle-check"></i>Document Accuracy</li>
                                        <li><i class="fa-solid fa-circle-check"></i>Experience & Expertise</li>
                                    </ul>
                                </div>
                            </div>
                            {/* <div class="row">
                                <div class="col-md-6 mb-20">
                                    <div class="tr-visa-details-thumb-sm wow img-custom-anim-top" data-wow-duration="1.5s" data-wow-delay=".3s">
                                        <img class="w-100" src="assets/img/inner/visa/details-sm-1.jpg" alt=""/>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-20">
                                    <div class="tr-visa-details-thumb-sm wow img-custom-anim-top" data-wow-duration="1.5s" data-wow-delay=".5s">
                                        <img class="w-100" src="assets/img/inner/visa/details-sm-2.jpg" alt=""/>
                                    </div>
                                </div>
                            </div>
                            <p class="mt-15 mb-50">Thorough review and preparation of all required documents for visa applications Ensuring accuracy, completeness, and compliance with immigration requirements Legal counsel and representation in complex immigration matters Advice
                                on legal implications, representation </p> */}
                            <div class="tr-custom-accordion">
                                <div class="accordion" id="accordionExample">
                                    <div class="accordion-items">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-buttons " type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Can you help with visa extensions or renewals?
                                 </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                            <div class="accordion-body d-flex align-items-center">
                                                <p class="mb-0">Processing times vary by visa type and country but typically range from a few weeks several months comprehensive corporate provide immigration services, including work permits</p>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-items">
                                        <h2 class="accordion-header" id="headingTwo">
                                            <button class="accordion-buttons collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                    What are the fees for your consulting services?
                                 </button>
                                        </h2>
                                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                            <div class="accordion-body d-flex align-items-center">
                                                <p class="mb-0">Processing times vary by visa type and country but typically range from a few weeks several months comprehensive corporate provide immigration services, including work permits</p>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-items">
                                        <h2 class="accordion-header" id="headingThree">
                                            <button class="accordion-buttons collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                    Do you offer services for corporate immigration?
                                 </button>
                                        </h2>
                                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                            <div class="accordion-body d-flex align-items-center">
                                                <p class="mb-0">Processing times vary by visa type and country but typically range from a few weeks several months comprehensive corporate provide immigration services, including work permits</p>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-lg-4">
                        <div class="tr-visa-details-sidebar">
                            <div class="sidebar-widget mb-30">
                                <h4 class="sidebar-widget-title mb-45">All Services</h4>
                                <div class="sidebar-widget-list">
                                    <a class="active" href="/studentvisa">Student Visa Services
                              <FontAwesomeIcon icon={faArrowRightLong} style={{ float: 'right' }}/>

                           </a>
                                    <a href="/TouristVisa">Tourist Visa Services
                              <FontAwesomeIcon icon={faArrowRightLong} style={{ float: 'right' }}/>

                           </a>
                                </div>
                            </div>
                            <div class="tr-visa-details-contact-box text-center">
                                {/* <h4 class="tr-visa-details-title text-white">Emergency Visa Services</h4> */}
                                <i>
                           <svg width="58" height="48" viewBox="0 0 58 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M29.3186 8.7681C39.0915 8.86449 45.2138 8.25326 46.0407 19.1419H57.9582C57.9582 2.27367 43.3231 0 29.0084 0C14.6926 0 0.0585938 2.27367 0.0585938 19.1419H11.8835C12.7984 8.04574 19.627 8.67284 29.3186 8.7681Z" fill="white" />
                              <path d="M5.96888 24.5647C8.87153 24.5647 11.2868 24.7393 11.8238 21.8692C11.896 21.4791 11.9378 21.0368 11.9378 20.5254H11.8001H0C0 24.7949 2.67251 24.5647 5.96888 24.5647Z" fill="white" />
                              <path d="M46.1173 20.5254H46.0056C46.0056 21.0402 46.0496 21.4836 46.132 21.8692C46.6983 24.5159 49.1102 24.3515 52.0027 24.3515C55.3149 24.3515 57.9998 24.5704 57.9998 20.5254H46.1173Z" fill="white" />
                              <path d="M40.2955 17.6177V15.9213C40.2955 15.1626 39.4257 15.115 38.3517 15.115H36.5975C35.5247 15.115 34.6549 15.1626 34.6549 15.9213V17.383V18.517H22.2456V17.383V15.9213C22.2456 15.1626 21.3758 15.115 20.303 15.115H18.5476C17.4748 15.115 16.605 15.1626 16.605 15.9213V17.6177V19.0987C13.7779 22.0517 4.52734 34.6221 4.19116 36.1439L4.19567 46.2989C4.19567 47.2367 4.9549 47.9999 5.88785 47.9999H51.0126C51.9456 47.9999 52.7048 47.2367 52.7048 46.2989V36.0929C52.372 34.6153 43.1237 22.0505 40.2955 19.0976V17.6177ZM21.6341 37.5104C20.726 37.5104 19.9893 36.771 19.9893 35.857C19.9893 34.943 20.726 34.2036 21.6341 34.2036C22.5423 34.2036 23.2789 34.943 23.2789 35.857C23.2789 36.771 22.5423 37.5104 21.6341 37.5104ZM21.6341 31.8404C20.726 31.8404 19.9893 31.101 19.9893 30.187C19.9893 29.273 20.726 28.5336 21.6341 28.5336C22.5423 28.5336 23.2789 29.273 23.2789 30.187C23.2789 31.101 22.5423 31.8404 21.6341 31.8404ZM21.6341 26.1715C20.726 26.1715 19.9893 25.4321 19.9893 24.5181C19.9893 23.6053 20.726 22.8648 21.6341 22.8648C22.5423 22.8648 23.2789 23.6053 23.2789 24.5181C23.2789 25.4321 22.5423 26.1715 21.6341 26.1715ZM28.4029 37.5104C27.4947 37.5104 26.7581 36.771 26.7581 35.857C26.7581 34.943 27.4947 34.2036 28.4029 34.2036C29.3121 34.2036 30.0477 34.943 30.0477 35.857C30.0477 36.771 29.3121 37.5104 28.4029 37.5104ZM28.4029 31.8404C27.4947 31.8404 26.7581 31.101 26.7581 30.187C26.7581 29.273 27.4947 28.5336 28.4029 28.5336C29.3121 28.5336 30.0477 29.273 30.0477 30.187C30.0477 31.101 29.3121 31.8404 28.4029 31.8404ZM28.4029 26.1715C27.4947 26.1715 26.7581 25.4321 26.7581 24.5181C26.7581 23.6053 27.4947 22.8648 28.4029 22.8648C29.3121 22.8648 30.0477 23.6053 30.0477 24.5181C30.0477 25.4321 29.3121 26.1715 28.4029 26.1715ZM35.1716 37.5104C34.2623 37.5104 33.5268 36.771 33.5268 35.857C33.5268 34.943 34.2623 34.2036 35.1716 34.2036C36.0808 34.2036 36.8164 34.943 36.8164 35.857C36.8164 36.771 36.0808 37.5104 35.1716 37.5104ZM35.1716 31.8404C34.2623 31.8404 33.5268 31.101 33.5268 30.187C33.5268 29.273 34.2623 28.5336 35.1716 28.5336C36.0808 28.5336 36.8164 29.273 36.8164 30.187C36.8164 31.101 36.0808 31.8404 35.1716 31.8404ZM35.1716 26.1715C34.2623 26.1715 33.5268 25.4321 33.5268 24.5181C33.5268 23.6053 34.2623 22.8648 35.1716 22.8648C36.0808 22.8648 36.8164 23.6053 36.8164 24.5181C36.8164 25.4321 36.0808 26.1715 35.1716 26.1715Z" fill="white" />
                            </svg>
                        </i>
                                <span class="text-white">Student Visa Services</span>
                                <h4 class="tr-visa-details-title text-white"><a class="border-line-white" href="tel:+918238823767">+91 8238823767</a></h4>
                                <p class="text-white mb-35">Navigating the student visa process can be complex, but our expert team is here to simplify it for you.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        

    </main>

  );
}

export default StudentVisa;